import { SlideTheme } from '../../types';

export const premiumReportTheme: SlideTheme = {
  colors: {
    primary: '#004F7E',
    white: '#FFFFFF',
    ghost: '#7D7D7D',
    neutral: '#353536',
  },
  fontFamily: {
    headings: 'Roboto',
    body: 'Roboto',
  },
  fontWeight: {
    regular: 400,
    medium: 500,
    bold: 600,
  },
  fontSize: {
    title: '40px',
    subtitle: '26px',
    sm: '16px',
    md: '26px',
    xs: '12px',
    xl: '40px',
  },
};
